export const ROUTE_CHANGE_ERROR = { message: 'Aborting route change' }

export const NOTE_CHAR_LIMIT = 600
export const BOGO_QUANTITY_INCREMENT = 2
export const DELIVERY_TYPES = {
  STANDARD: 'standard',
  PICKUP: 'pickup',
}

// ------ SEARCH CONSTANTS --------

export const SORT_BY_PARAMS = {
  PRICE_LOW_TO_HIGH: 'price_low_to_high',
  PRICE_HIGH_TO_LOW: 'price_high_to_low',
  RECENCY: 'recency',
}

export const SORT_BY_TEXTS = {
  BEST_MATCH: 'Best match',
  MOST_POPULAR: 'Most popular',
  MOST_RECENT: 'Most recent',
  MOST_FREQUENT: 'Most frequent',
  PRICE_LOWEST_FIRST: 'Price: lowest first',
  PRICE_HIGHEST_FIRST: 'Price: highest first',
}

export const SEARCH_SORT_BY_OPTIONS = {
  [SORT_BY_PARAMS.PRICE_LOW_TO_HIGH]: SORT_BY_TEXTS.PRICE_LOWEST_FIRST,
  [SORT_BY_PARAMS.PRICE_HIGH_TO_LOW]: SORT_BY_TEXTS.PRICE_HIGHEST_FIRST,
}

export const SORT_BY_OPTIONS = {
  ...SEARCH_SORT_BY_OPTIONS,
}

export enum SEARCH_FILTER_TYPE {
  CATEGORY = 'categories',
  ACTIVE_DEALS = 'active_deals',
  BRAND = 'brands',
  SORT_BY = 'sort_by',
  ON_SALE = 'on_sale',
  STORE = 'store_id',
  FLAVOR = 'flavors',
}

export type SEARCH_FILTER_TYPE_FACET = SEARCH_FILTER_TYPE.BRAND | SEARCH_FILTER_TYPE.FLAVOR

export const SEARCH_FACETS = {
  ACTIVE_DEALS: 'active_deals',
  BRAND: 'brand_name',
  CATEGORIES: 'categories',
  H1_CATEGORIES: 'h1categories',
  H2_CATEGORIES: 'h2categories',
  H3_CATEGORIES: 'h3categories',
  FLAVOR: 'flavors',
}

export const UNIVERSAL_SEARCH_FACETS = {
  BRAND: 'brand_name',
  STORE: 'store_id',
}

export const SORT_BY_FACET = {
  id: 0,
  items: [],
  name: 'Sort by',
  facet: SEARCH_FILTER_TYPE.SORT_BY,
}

export enum CATEGORY_HEADER_TYPE {
  MORE = 'More',
  DEALS = 'Deals',
  BUY_AGAIN = 'Buy Again',
  STORE_PRICING = 'Store pricing',
  LISTS = 'Lists',
  DELIVERY_WINDOW = 'Delivery window',
  STORE_SELECTOR = 'Store selector',
  STORE_REWARDS = 'Store rewards',
  CART_BUILDER = 'Cart Builder',
}

export enum BACKUP_PREFERENCE_SELECTION {
  CONTACT_ME = 'Contact me',
  DO_NOT_SUBSTITUTE = 'Do not substitute',
  GET_A_BACKUP_ITEM = 'Get a backup item',
  NULL = 'null',
}

export const SUGGESTION_TYPES = {
  STANDARD: 'standard',
  POPULAR: 'popular',
  POPULAR_IMAGE: 'popular_image',
  PERSONALIZED: 'personalized',
  CORRECTION: 'correction',
  PERSONALIZED_RECENT: 'personalized_recent',
  PERSONALIZED_RECENT_IMAGE: 'personalized_recent_image',
  PERSONALIZED_POPULAR: 'personalized_popular',
  PERSONALIZED_POPULAR_IMAGE: 'personalized_popular_image',
  IMAGE_SUGGESTION: 'ImageSuggestion',
}

export const HEADER_DEFAULT_Y = 72
export const HEADER_Z_INDEX = 1000

export const PURCHASE_HISTORY_PAGE_SIZE = 48

export enum GuestDataStore {
  ADDRESS = 'guest_user_address',
  STORE = 'guest_user_store',
}

export const Z_INDEX_MAX = 2147483647
export const Z_INDEX_MODAL = Z_INDEX_MAX - 1

// any shelf less than this will not be lazy loaded. This is a measure to reduce CLS
export const EAGER_LOAD_SHELF_INDEX = 5
